import { Nav } from './sections/Nav';
import { Hero } from './sections/Hero';
import { Capabilities } from './sections/Capabilities';
import { Products } from './sections/Products';
import { About } from './sections/About';
import { Newsletter } from './sections/Newsletter';
import { Contact } from './sections/Contact';
import { Footer } from './sections/Footer';

export function App() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Capabilities />
        <Products />
        <About />
        <Newsletter />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
